<template>
  <span :style="wrapperStyle">
    <label v-if="fieldLabel" class="form-field-label" :for="uniqueTitle">{{ fieldLabel }}</label>
    <b-form-file
      v-model="file"
      :state="Boolean(file)"
      :id="uniqueTitle"
      :name="uniqueTitle"
      :placeholder="placeholder || undefined"
      :disabled="isReadonly"
      :aria-describedby="describedBy"
      :class="{ 'form-field-readonly': isReadonly }"
      @input="onInput"
    >
    </b-form-file>
    <div v-if="file && file.name" class="mt-3">Selected file: {{ file.name }}</div>
    <label v-if="allowImageUrl" class="image-url-label">
      Or an image address
      <input class="form-control" type="url" :value="imageUrl" placeholder="https://..." :disabled="isReadonly" @input="onUrl" />
    </label>
  </span>
</template>

<script>
import { inject, computed } from 'vue'
import { formattingToStyle } from '../../lib/client-rule-evaluator'

export default {
  props: ['placeholder', 'uniqueTitle', 'fieldLabel', 'description', 'allowImageUrl'],
  setup (props) {

    const formFormatting = inject('formFormatting', null)
    const formReadonly = inject('formReadonly', null)
    const updateFormValue = inject('updateFormValue', null)

    const wrapperStyle = computed(() => {
      if (!formFormatting || !props.uniqueTitle) return {}
      const fmt = formFormatting[props.uniqueTitle]
      return fmt ? formattingToStyle(fmt) : {}
    })

    const isReadonly = computed(() => {
      if (!formReadonly || !props.uniqueTitle) return false
      return !!formReadonly[props.uniqueTitle]
    })

    const describedBy = computed(() => {
      return props.description ? `${props.uniqueTitle}-description` : undefined
    })

    return { formFormatting, formReadonly, updateFormValue, wrapperStyle, isReadonly, describedBy }
  },
  data () {
    return {
      file: null,
      file2: null,
      imageUrl: ''
    }
  },
  methods: {
    onInput () {
      if (this.updateFormValue && this.file) {
        this.updateFormValue(this.uniqueTitle, this.file.name)
      }
    },
    onUrl (event) {
      this.imageUrl = event.target.value
      if (!this.updateFormValue) return
      const url = String(this.imageUrl || '').trim()
      this.updateFormValue(this.uniqueTitle, url ? { url } : '')
    }
  }
}
</script>

<style scoped>
.image-url-label {
  display: block;
  margin-top: 8px;
}
</style>
